export default {
  title: '한국 : React + Typescipt + Redux + RxJs + Multi Language',
  test: '영어 블록체인 산업의 발전 후오비 코리아가 함께합니다.',
  testBtn: '테스트',
};


// WEBPACK FOOTER //
// ./src/locales/en-US/guide.ts